import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ClusterNode, DagreSettings, Orientation } from '@swimlane/ngx-graph';
import * as shape from 'd3-shape';
import { SwimService } from '../vansh2/swim.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-swim2',
  templateUrl: './swim2.component.html',
  styleUrls: ['./swim2.component.scss'],
})
export class Swim2Component implements OnInit {
  @ViewChild('graphContainer') graphContainer!: ElementRef;
  @Input() zoomFactor = 1.2;
  clusters: ClusterNode[] = [];
  curve: any = shape.curveLinear;

  @Input() update$;
  @Input() center$;
  @Input() zoomToFit$;

  @Input() selectedNode: any;

  @Output() clickRelation = new EventEmitter<any>();
  @Output() clickSpouse = new EventEmitter<any>();
  @Output() clickNode = new EventEmitter<any>();
  @Output() clickImage = new EventEmitter<any>();
  @Output() clickSpouseImage = new EventEmitter<any>();

  @Input() captureImage = false;

  constructor(public swim: SwimService, public auth: AuthService) { }

  ngOnInit() {
    this.curve = shape.curveBundle.beta(1);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // console.log(changes);
    if (changes.captureImage && changes.captureImage.currentValue) {
      this.generateGraphImage(this.graphContainer);
      this.captureImage = false;
    }
  }
  dagreSettings: DagreSettings = {
    orientation: Orientation.LEFT_TO_RIGHT, // Top-to-bottom layout; options are 'LR' (left-to-right), 'TB' (top-to-bottom), etc.
    rankPadding: 150,       // Increases the vertical space between nodes
  };

  // generateGraphImage(graphElement: ElementRef): void {
  //   const canvas = document.getElementById('ngxGraph')
  //   const img = canvas.toDataURL('image/png')
  // }
  generateGraphImage(graphElement: ElementRef): string | void {
    const svgElement = graphElement.nativeElement.querySelector('ngx-graph svg');

    if (!svgElement) {
      console.error('SVG element not found.');
      return;
    }

    const width = svgElement.scrollWidth;
    const height = svgElement.scrollHeight;

    // Clone the SVG and set dimensions
    const clonedSvg = svgElement.cloneNode(true) as SVGSVGElement;
    clonedSvg.setAttribute('width', width.toString());
    clonedSvg.setAttribute('height', height.toString());

    // Serialize the SVG to a string
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(clonedSvg);

    // Create a blob from the SVG string and load it into an image
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.fillStyle = 'white';  // Set background to white
      ctx.fillRect(0, 0, width, height);

      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);

        // Convert canvas to PNG and download
        canvas.toBlob((blob) => {
          if (blob) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'ngx-graph.png';
            link.click();
          }
        }, 'image/png');
      };
      img.src = url;
    } else {
      console.error('Unable to get canvas context.');
    }
  }
}
